module.exports = __webpack_public_path__ + "media/site_templates/www.furnituredisposal.com.au/images/our_services_3-6abdd60ec3a580369c356c54278c74a2.jpg";